/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * DermOnCall Patient API
 * OpenAPI spec version: 1.0
 */
import { useQuery } from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseQueryOptions,
  UseQueryResult,
} from '@tanstack/react-query';

import type { GetEncounterWorkflowErrorResponse, WorkflowResponse } from './api.schemas';

import { api } from '../util/http';

export const getEncountersWorkflow = (encounterId: number, signal?: AbortSignal) => {
  return api<WorkflowResponse>({
    url: `/api/encounters/${encounterId}/workflow`,
    method: 'GET',
    signal,
  });
};

export const getGetEncountersWorkflowQueryKey = (encounterId?: number) => {
  return [`/api/encounters/${encounterId}/workflow`] as const;
};

export const getGetEncountersWorkflowQueryOptions = <
  TData = Awaited<ReturnType<typeof getEncountersWorkflow>>,
  TError = GetEncounterWorkflowErrorResponse,
>(
  encounterId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getEncountersWorkflow>>, TError, TData>
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetEncountersWorkflowQueryKey(encounterId);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getEncountersWorkflow>>> = ({ signal }) =>
    getEncountersWorkflow(encounterId, signal);

  return { queryKey, queryFn, enabled: !!encounterId, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getEncountersWorkflow>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetEncountersWorkflowQueryResult = NonNullable<
  Awaited<ReturnType<typeof getEncountersWorkflow>>
>;
export type GetEncountersWorkflowQueryError = GetEncounterWorkflowErrorResponse;

export function useGetEncountersWorkflow<
  TData = Awaited<ReturnType<typeof getEncountersWorkflow>>,
  TError = GetEncounterWorkflowErrorResponse,
>(
  encounterId: number,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getEncountersWorkflow>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getEncountersWorkflow>>,
          TError,
          Awaited<ReturnType<typeof getEncountersWorkflow>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetEncountersWorkflow<
  TData = Awaited<ReturnType<typeof getEncountersWorkflow>>,
  TError = GetEncounterWorkflowErrorResponse,
>(
  encounterId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getEncountersWorkflow>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getEncountersWorkflow>>,
          TError,
          Awaited<ReturnType<typeof getEncountersWorkflow>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetEncountersWorkflow<
  TData = Awaited<ReturnType<typeof getEncountersWorkflow>>,
  TError = GetEncounterWorkflowErrorResponse,
>(
  encounterId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getEncountersWorkflow>>, TError, TData>
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

export function useGetEncountersWorkflow<
  TData = Awaited<ReturnType<typeof getEncountersWorkflow>>,
  TError = GetEncounterWorkflowErrorResponse,
>(
  encounterId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getEncountersWorkflow>>, TError, TData>
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetEncountersWorkflowQueryOptions(encounterId, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}
